import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  {path: "", redirectTo: "inventario/form/novo", pathMatch: "full"},

  // Redirect empty path to '/example'
  // { path: '', pathMatch: 'full', redirectTo: 'example' },

  // Redirect signed-in user to the '/example'
  //
  // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  {path: "signed-in-redirect", pathMatch: "full", redirectTo: "example"},

  // Auth routes for guests
  {
    path: "",
    canMatch: [NoAuthGuard],
    component: LayoutComponent,
    data: {layout: "empty"},
    children: [
      {
        path: "confirmation-required",
        loadChildren: () =>
          import(
            "app/modules/auth/confirmation-required/confirmation-required.module"
          ).then(m => m.AuthConfirmationRequiredModule),
      },
      {
        path: "forgot-password",
        loadChildren: () =>
          import(
            "app/modules/auth/forgot-password/forgot-password.module"
          ).then(m => m.AuthForgotPasswordModule),
      },
      {
        path: "reset-password",
        loadChildren: () =>
          import("app/modules/auth/reset-password/reset-password.module").then(
            m => m.AuthResetPasswordModule
          ),
      },
      {
        path: "sign-in",
        loadChildren: () =>
          import("app/modules/auth/sign-in/sign-in.module").then(
            m => m.AuthSignInModule
          ),
      },
      {
        path: "sign-up",
        loadChildren: () =>
          import("app/modules/auth/sign-up/sign-up.module").then(
            m => m.AuthSignUpModule
          ),
      },
    ],
  },

  {
    path: "",
    canMatch: [NoAuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      {
        path: "combustivel",
        loadChildren: () =>
          import("app/modules/combustivel/combustivel.module").then(
            m => m.CombustivelModule
          ),
      },
      {
        path: "fertilizante",
        loadChildren: () =>
          import("app/modules/fertilizante/fertilizante.module").then(
            m => m.FertilizanteModule
          ),
      },
      {
        path: "mapa",
        loadChildren: () =>
          import("app/modules/mapa/mapa.module").then(m => m.MapaModule),
      },
      {
        path: "residuos-agricolas",
        loadChildren: () =>
          import(
            "app/modules/residuos-agricolas/residuos-agricolas.module"
          ).then(m => m.ResiduosAgricolasModule),
      },
      {
        path: "residuo-solido-efluente",
        loadChildren: () =>
          import(
            "app/modules/residuo-solido-efluente/residuo-solido-efluente.module"
          ).then(m => m.ResiduoSolidoEfluenteModule),
      },
      {
        path: "energia-eletrica",
        loadChildren: () =>
          import("app/modules/energia-eletrica/energia-eletrica.module").then(
            m => m.EnergiaEletricaModule
          ),
      },
      {
        path: "manejo-solos-organicos",
        loadChildren: () =>
          import(
            "app/modules/manejo-solos-organicos/manejo-solos-organicos.module"
          ).then(m => m.ManejoSolosOrganicosModule),
      },
      {
        path: "atividades_terceirizadas",
        loadChildren: () =>
          import(
            "app/modules/atividades-terceirizadas/atividades-terceirizadas.module"
          ).then(m => m.AtividadesTerceirizadasModule),
      },
      {
        path: "criacao-pecuaria",
        loadChildren: () =>
          import(
            "app/modules/manejo-dejetos-fermentacao-enterica/manejo-dejetos-fermentacao-enterica.module"
          ).then(m => m.ManejoDejetosFermentacaoEntericaModule),
      },
      {
        path: "inventario-sumidouros",
        loadChildren: () =>
          import(
            "app/modules/inventario-sumidouro/inventario-sumidouro.module"
          ).then(m => m.InventarioSumidouroModule),
      },
      {
        path: "produtos-florestais-madereiros",
        loadChildren: () =>
          import(
            "./modules/produtos-florestais-madereiros/produtos-florestais-madereiros.module"
          ).then(m => m.ProdutosFlorestaisMadereirosModule),
      },
      {
        path: "emissoes-fugitivas",
        loadChildren: () =>
          import(
            "app/modules/emissoesFugitivas/emissoes-fugitivas.module"
          ).then(m => m.EmissoesFugitivasModule),
      },
      {
        path: "mudanca-carbono-solo",
        loadChildren: () =>
          import(
            "app/modules/mudanca-carbono-solo/mudanca-carbono-solo.module"
          ).then(m => m.MudancaCarbonoSoloModule),
      },
      {
        path: "mudanca-uso-solo",
        loadChildren: () =>
          import("app/modules/mudanca-uso-solo/mudanca-uso-solo.module").then(
            m => m.MudancaUsoSoloModule
          ),
      },
      {
        path: "inventario-ilpf",
        loadChildren: () =>
          import("app/modules/inventario-ilpf/inventario-ilpf.module").then(
            m => m.InventarioIlpfModule
          ),
      },
      {
        path: "inventario-cultivo-arroz",
        loadChildren: () =>
          import(
            "app/modules/inventario-cultivo-arroz/inventario-cultivo-arroz.module"
          ).then(m => m.InventarioCultivoArrozModule),
      },
      {
        path: "inventario-agricultura-perene",
        loadChildren: () =>
          import(
            "app/modules/inventario-agricultura-perene/inventario-agricultura-perene.module"
          ).then(m => m.InventarioAgriculturaPereneModule),
      },
      { 
        path: "residuo_solido_agropecuario", 
        loadChildren: () => 
          import("app/modules/residuo-solido-agropecuario/residuo-solido-agropecuario.module").then(m => m.ResiduoSolidoAgropecuarioModule),
      },
      {
        path: "defensivos-agricolas",
        loadChildren: () =>
          import(
            "app/modules/defensivos-agricolas/defensivos-agricolas.module"
          ).then(m => m.DefensivosAgricolasModule),
      },
    ],
  },

  // Auth routes for authenticated users
  {
    path: "",
    canMatch: [AuthGuard],
    component: LayoutComponent,
    data: {layout: "empty"},
    children: [
      {
        path: "sign-out",
        loadChildren: () =>
          import("app/modules/auth/sign-out/sign-out.module").then(
            m => m.AuthSignOutModule
          ),
      },
      {
        path: "unlock-session",
        loadChildren: () =>
          import("app/modules/auth/unlock-session/unlock-session.module").then(
            m => m.AuthUnlockSessionModule
          ),
      },
    ],
  },

  // Landing routes
  {
    path: "",
    component: LayoutComponent,
    data: {layout: "empty"},
    children: [
      {
        path: "home",
        loadChildren: () =>
          import("app/modules/landing/home/home.module").then(
            m => m.LandingHomeModule
          ),
      },
    ],
  },

  // Admin routes
  {
    path: "",
    canMatch: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      {
        path: "example",
        loadChildren: () =>
          import("app/modules/admin/example/example.module").then(
            m => m.ExampleModule
          ),
      },
      {
        path: "inventario",
        loadChildren: () =>
          import("app/modules/inventario/inventario.module").then(
            m => m.InventarioModule
          ),
      },
      {
        path: "combustivel",
        loadChildren: () =>
          import("app/modules/combustivel/combustivel.module").then(
            m => m.CombustivelModule
          ),
      },
      {
        path: "fertilizante",
        loadChildren: () =>
          import("app/modules/fertilizante/fertilizante.module").then(
            m => m.FertilizanteModule
          ),
      },
      {
        path: "mapa",
        loadChildren: () =>
          import("app/modules/mapa/mapa.module").then(m => m.MapaModule),
      },
      {
        path: "residuos-agricolas",
        loadChildren: () =>
          import(
            "app/modules/residuos-agricolas/residuos-agricolas.module"
          ).then(m => m.ResiduosAgricolasModule),
      },

      {
        path: "residuoSolidoEfluente",
        loadChildren: () =>
          import(
            "app/modules/residuo-solido-efluente/residuo-solido-efluente.module"
          ).then(m => m.ResiduoSolidoEfluenteModule),
      },
      {
        path: "manejo-solos-organicos",
        loadChildren: () =>
          import(
            "app/modules/manejo-solos-organicos/manejo-solos-organicos.module"
          ).then(m => m.ManejoSolosOrganicosModule),
      },
      {
        path: "inventario-ilpf",
        loadChildren: () =>
          import("app/modules/inventario-ilpf/inventario-ilpf.module").then(
            m => m.InventarioIlpfModule
          ),
      },
    ],
  },
];
